/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

'use es6';

let uiUpdated = false;
function hasFilterChanges(currentFilters, updates) {
  return Object.keys(updates).some(key => {
    const newVal = updates[key];
    const oldVal = currentFilters[key];
    return Array.isArray(newVal) ? JSON.stringify([...newVal].sort()) !== JSON.stringify([...(oldVal || [])].sort()) : newVal !== oldVal;
  });
}
export default (({
  getState
}) => next => action => {
  const {
    type
  } = action;
  if (type === 'storefront/filters/updateFromLocation' && uiUpdated) {
    uiUpdated = false;
    return null;
  }
  if (type === 'storefront/filters/update') {
    const {
      multiSelectFilters
    } = getState().storefront;
    if (!hasFilterChanges(multiSelectFilters, action.payload.updates)) {
      return null;
    }
    uiUpdated = true;
  }
  if (type === 'storefront/filters/clearFilters') {
    uiUpdated = true;
  }
  if (type === 'storefront/filters/updateFromLocation' || type === 'storefront/filters/update') {
    action.payload.catalogServices = getState().services.services;
  }
  return next(action);
});